var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x93\xD0\xBE\xD0\xBB\xD0\xBE\xD0\xB2\xD0\xBD\xD0\xB5 \xD0\xBC\xD0\xB5\xD0\xBD\xD1\x8E \xD0\xB4\xD0\xBE\xD0\xB4\xD0\xB0\xD1\x82\xD0\xBA\xD1\x83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7778 1H4V23L20 23V5.4M15.7778 1C17.4244 2.716 18.3533 3.684 20 5.4M15.7778 1V5.4L20 5.4M7.33333 9.8H15.7778M7.33333 12.3667H15.7778M7.33333 18.6H9.44444H11.5556M7.33333 15.1167H15.7778",
    stroke: "#57486D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDocuments);
export default __webpack_public_path__ + "static/media/card-documents.47fcf6ee04b75c6893aba679bf167dde.svg";
export { ForwardRef as ReactComponent };